import { useSite } from "@/lib/useSite";

const FALLBACK = [
  "Colour Coated Roofing Sheets",
  "Bamboo Tile Sheets",
  "Linear Profile",
  "Synthetic Roof Thatch",
  "UPVC Spanish Tile Sheets",
  "GI Chain Links",
  "MS Welded Mesh",
  "Goat Mats",
  "MS Pipes · Angles · Channels · Rods",
  "Stronger Roofs",
  "Safer Spaces",
  "Happier Tomorrows",
];

export default function Marquee() {
  const { data } = useSite();
  const names = data?.products?.length ? data.products.map((p) => p.title) : FALLBACK;
  const items = [...names, ...names];

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-b border-ink/10 bg-white py-7" aria-hidden="true">
      <div className="flex w-max animate-srs-marquee items-center">
        {items.map((name, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-10 font-display text-3xl font-medium tracking-tight text-ink/20 sm:text-4xl">
              {name}
            </span>
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-srs" />
          </span>
        ))}
      </div>
    </div>
  );
}
